import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Customer } from '@df/session/api/customer';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { LocalCustomerModel } from '../../../customer/customer.model.decorator';
import { NAntavo } from '../../../module/antavo/antavo.interface';
import { AntavoService } from '../../../module/antavo/antavo.service';

/**
 * Resolver to load Antavo rewards and associated product data for the rewards page
 */
export const accountRewardsResolver: ResolveFn<NAntavo.IEnhancedReward[] | undefined> = async () => {
    const antavoService = inject(AntavoService);
    const customer = inject(Customer);

    const customerModel = (await customer.model.load()) as LocalCustomerModel;

    if (!customerModel?.loyaltyId) {
        return undefined;
    }

    try {
        return await antavoService.getEnhancedRewards({ loyaltyId: customerModel.loyaltyId });
    } catch (error) {
        console.error('Failed to load rewards:', error);
        return undefined;
    }
};
